import { createAsyncThunk } from "@reduxjs/toolkit";
import { getOrganizationCustomerByCustomerIdAndRestaurantId } from "../../../utils/APICalls/APICalls";
import { OrganizationCustomer } from "../../../utils/types";

export const getOrganizationCustomerData = createAsyncThunk(
  "fetchCustomerData",
  async (restaurantId: number) => {
    const organizationCustomer: { data: OrganizationCustomer } =
      await getOrganizationCustomerByCustomerIdAndRestaurantId(restaurantId);

    return organizationCustomer.data;
  }
);
